(function () {
    angular.module('website-activity-condition.dir', ['ngclipboard'])
        .directive('websiteActivityCondition', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', 'CANVAS_OPTS', '$timeout', websiteActivity]);

    function websiteActivity($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, CANVAS_OPTS, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.wasSave = false;

                $scope.breakUrl = () => {
                    return $scope.connections.data.specificUrl.replace(/(.{70})/g, "$1<br />");
                };

                //When we save a the form
                $scope.save = function (trackCoach = true, dummy) {
                    //If form data is missing
                    if ($scope.dataFilledCorrectly() === false) {
                        $rootScope.$emit('displayConditionWebsiteActivityModalError');
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        if($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                        if(!dummy && $scope.connections.isDummy) {
                            delete $scope.connections.isDummy;
                        }

                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
                        $scope.trackingTestClass = '';

                        //Updates the parent to register its children
                        var parentData = helpers.getConnectionById($scope.connections.parent);
                        if(parentData){
                            parentData.children = [];
                            parentData.children.push($scope.connections.id);
                            helpers.updateConnections(parentData);
                        }
                        //Save to the global canvas object
                        helpers.updateConnections($scope.connections);

                        if(!$scope.connections.isDummy) {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.unsavedData.splice(index, 1);
                            }
                        }

                        //Displays th form data
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionWebsiteActivityModal');
                        //Displays action menu
                        $scope.displaySubMenu = false;
                        //Hides Error
                        $scope.displayError = false;
                        $scope.specificUrlError = false;
                        //Save Journey to template
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                        if ($scope.isElegibleForUpdate) {
                            $scope.wasSave = true;
                            $timeout(() => {
                                $scope.wasSave = false;
                            }, 2000);
                        }
                        //Set Back to autoSave
                        $scope.isElegibleForUpdate = true;
                        //Remove Activate Error since its being able to save
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;
                    }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                //Validates if data is filled correctly or not
                $scope.dataFilledCorrectly = function () {
                    var res = true;

                    if (!$scope.connections.data.source) {

                        $scope.displayError = true;
                        res = false;

                    }

                    if ($scope.connections.data.source !== 'any-tracked-page' &&
                        ($scope.connections.data.specificUrl === undefined ||
                        $scope.connections.data.specificUrl === '' ||
                        $scope.specificUrlError === true)) {

                        $scope.specificUrlError = true;
                        res = false;

                    }

                    if(!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return res;
                };

                //Cancel Button
                $scope.cancel = function () {

                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if(conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if(newTop !== $scope.connections.top || $scope.connections.left !== newLeft){
                        $scope.displayList = false;
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if(!wasUpdated){
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }

                        $rootScope.$emit('hideConditionWebsiteActivityModal');

                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayConditionWebsiteActivityModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
                        $scope.trackingTestClass = '';
                        $rootScope.$emit('hideConditionWebsiteActivityModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.setLastElem = function(evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    }
                    else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $scope.$broadcast('setMenuDefaults');
                            $rootScope.$emit('hideConditionWebsiteActivityModal');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1 || $scope.connections.isDummy) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionWebsiteActivityModal', $scope.connections);
                            } else if ($scope.dataFilledCorrectly() === false) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayConditionWebsiteActivityModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideConditionWebsiteActivityModal');
                            }
                            else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideConditionWebsiteActivityModal');
                            }
                        }
                    }
                };

                $scope.showTipModal = () => {
                    // displays tip modal
                    $rootScope.$emit('displayConditionWebsiteActivityModal', $scope.connections, true);
                };

                $scope.parseDescription = function (desc, specificUrl) {
                    if (specificUrl) {
                        if (desc) {
                            var arrLen = desc.split("");
                            arrLen = arrLen.length;
                            if (arrLen > 15) {
                                return desc.slice(0, 15) + '...';
                            } else {
                                return desc;
                            }
                        } else if ($scope.connections.data.source === 'contains-url') {
                            return $scope.translate('canvas.entry.websiteEngagement.containsUrl');
                        } else {
                            return $scope.translate('canvas.condition.websiteActivity.specificUrl');
                        }
                    } else {
                        if (desc) {
                            desc = $scope.translate('canvas.condition.websiteActivity.anyTracked');
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                        return desc;
                    }
                };

                $scope.$watch('connections', (conn) => {
                    if(conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if(conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function (scope, elem, attr) {
                // scope data initialization
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.displayForm = true;
                scope.token = $rootScope.getTrackerToken;
                scope.isElegibleForUpdate = true;
                scope.trackingTestState = scope.translate('canvas.entry.websiteEngagement.url.test');
                scope.trackingTestClass = '';
                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections){
                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = false;

                    if (scope.connections.data.specificUrl) {
                        scope.specificUrl = true;
                        scope.append = true;
                    }

                    if(!scope.token) {
                        $rootScope.$watch('getTrackerToken', function(token) {
                            if(token) {
                                scope.trackingCode = helpers.generateTrackerScript(token);
                            }
                        });
                    }else {
                        scope.trackingCode = helpers.generateTrackerScript(scope.token);
                    }

                    //Load Template
                    var template = $templateCache.get('conditions/website-activity');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveConditionWebsiteActivityData' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    if(scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(() => {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000)
                    } else if(scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save(false, true);
                }

                $(elem).click(function (evt) {
                    scope.trackingTestState = scope.translate('canvas.entry.websiteEngagement.url.test');
                    scope.trackingTestClass = '';

                    if(!scope.token) {
                        $rootScope.$watch('getTrackerToken', function(token) {
                            if(token) {
                                scope.trackingCode = helpers.generateTrackerScript(token);
                            }
                        });
                    }else {
                        scope.trackingCode = helpers.generateTrackerScript(scope.token);
                    }

                    $rootScope.activePlus = false;

                    //Load Template
                    var template = $templateCache.get('conditions/website-activity'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: (lastElement.type == 'RectangleConnection') ? (lastElement.top - 43) : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Condition',
                        data: {source: "any-tracked-page", specificUrl:undefined},
                        elemClass: attr.$attr,
                        elemName: 'WebActivity',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function() {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;
                    });

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);

                    plumbService.connectElements(lastElement, scope.connections);

                    scope.manualConnection = function() {
                        plumbService.manualConnection(scope.connections);
                    };

                    $rootScope.$on('saveConditionWebsiteActivityData' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the web site activity node
                    $rootScope.$on('deleteWebSiteActivityNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    $rootScope.$emit('displayConditionWebsiteActivityModal', scope.connections);
                });

                scope.deleteElement = function() {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                        $rootScope.activePlus = true;
                    }else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function() {
                    if(scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_directives/website-activity-condition.js